/**
 * Can this «recent tenders / recent contracts» row be named at all?
 *
 * A row on `/buyer/:tin` or `/supplier/:tin` is labelled by the harvested lot's
 * title, else the ИКПУ product name, else — on the Pro tier only — the
 * counterparty. The public tier redacts precisely the counterparty, so a row with
 * no lot link and no title reached the page as «— / 1 млрд сум / 26 августа 2026»:
 * an amount and a date attached to an unnamed thing. QA found 5 such rows in 69
 * across 12 sampled indexable buyer profiles (2026-09-26); measured over the
 * recent-8 window of every company with awarded results the same day, 2 746 of
 * 39 769 buyer rows (6.9 %) and 6 151 of 81 265 supplier rows (7.6 %).
 *
 * The API omits them from the public projection (`nameableRecentRows` in
 * `public-profile.ts`), and this is the SAME rule applied again on the page —
 * deliberately, not redundantly: the public payload is Redis-cached for 6 hours
 * and then BAKED into the prerendered HTML, so the page has to render correctly
 * against a payload produced before the fix (a cache entry mid-TTL, a release
 * whose API is one deploy behind) instead of painting a dash and waiting.
 *
 * No count is affected. `totalAwards`, `procurement12m` and `categoryMix` are
 * their own aggregates over the whole award graph; this eight-row window is not
 * the denominator of any of them, and the section heading carries no count.
 */
export function isNameableRow(row: { tenderId: string | null; title: string | null }): boolean {
  return row.tenderId != null || (row.title != null && row.title.trim() !== '');
}
